module.exports = __webpack_public_path__ + "static/media/ua-lamp-image-1.921afacb.jpg";